import styled from 'styled-components';
import SuccessPageButton from 'views/PostEnrollment/SuccessPageButtons';

import { METAL_CARD_SELECTED } from 'consts/storageConsts';

import { IS_EMBEDDED } from 'utils/queryParamHelpers';
import { getFromLocalStorage } from 'utils/storage/storageHelper';

import SuccessPageImage from './components/SuccessPageImage';
import { SuccessPageLayout } from './components/SuccessPageLayout';

export function SuccessPage() {
  const isMetalCardSelected = !!getFromLocalStorage(METAL_CARD_SELECTED);

  return (
    <SuccessPageLayout>
      <PageTitle>
        {IS_EMBEDDED
          ? 'Your account is ready'
          : 'Your account is waiting in the app'}
      </PageTitle>
      {isMetalCardSelected && (
        <PageSubtitle>Sign in and secure your metal card.</PageSubtitle>
      )}
      <SuccessPageImage isMetalCardSelected={isMetalCardSelected} />
      <ButtonContainer>
        <SuccessPageButton eventContext="success_page">
          Get the app
        </SuccessPageButton>
      </ButtonContainer>
    </SuccessPageLayout>
  );
}

const PageTitle = styled.h1`
  font-size: ${props => props.theme.styles.titles.fontSize};
  line-height: ${props => props.theme.styles.titles.lineHeight};
  margin: 0;
`;

const ButtonContainer = styled.div`
  margin: 0 auto;
  width: 20.5rem;
  height: auto;
  display: flex;
  justify-content: center;
`;

const PageSubtitle = styled.p`
  margin: 0;
`;
